<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.administracao.papel"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('administracao-papel-update')"
                :to="{name: 'administracao-papel-edit', params: {id: item.papel_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('administracao-papel-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'papel_nome',
                    label: 'Nome',
                    name: 'administracao_papel.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.papel.destroy(item.papel_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir o papel ${item.papel_nome}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>